<section class="content">
  <h2 class="pb-s">Benachrichtigungen</h2>

  <p>
    Hier können Sie verschiedene Kommunikationskanäle auswählen und abonnieren, um Benachrichtigungen per Mail und/oder
    SMS zu den von Ihnen ausgewählten Themen zu erhalten. Die Abonnements können jederzeit geändert oder gelöscht
    werden. </p>

  <ng-container>
    @if ((pharmacies?.length ?? 0) > 0) {
      <mat-accordion>
        @for (pharmacy of pharmacies; track pharmacy.idf) {
          <mat-expansion-panel (opened)="selectPharmacy(pharmacy.idf)" class="mb-m">
            <mat-expansion-panel-header>
              <mat-panel-title> {{ pharmacy.idf }} {{ pharmacy.name }}</mat-panel-title>
            </mat-expansion-panel-header>
            <table mat-table [dataSource]="pharmaTypes">

              <ng-container matColumnDef="label">
                <th mat-header-cell *matHeaderCellDef>Abonnements</th>
                <td mat-cell *matCellDef="let type">
                  {{ type.label }}
                  <mat-icon fontSet="material-symbols-outlined" aria-hidden="false" [matTooltip]="type.tooltip">info
                  </mat-icon>
                </td>
              </ng-container>

              <ng-container matColumnDef="toggle">
                <th mat-header-cell *matHeaderCellDef class="text-center">Abonnieren</th>
                <td mat-cell *matCellDef="let type" class="text-center">
                  @if (type.value === 'TRACK_TRACE') {
                    <img
                      class="locked-toggle"
                      src="assets/tiles/locked-toggle.svg"
                      alt="Dieses Abonnement ist verpflichtend und kann nicht deaktiviert werden."
                      matTooltip="Dieses Abonnement ist verpflichtend und kann nicht deaktiviert werden."/>
                  } @else {
                    <mat-slide-toggle
                      [id]="type.value"
                      [checked]="isConfigActive(type)"
                      (change)="changeConfig($event, type, pharmacy.idf)"
                      [attr.aria-label]="'Abonnement für ' + type.label + ' umschalten'">
                    </mat-slide-toggle>
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="text-center">Kontaktdaten</th>
                <td mat-cell *matCellDef="let type" class="text-center">
                  <button mat-icon-button (click)="openDialog(type, pharmacy.idf)">
                    <mat-icon fontSet="material-symbols-outlined" aria-hidden="false">edit</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="['label', 'toggle', 'actions']"></tr>
              <tr mat-row *matRowDef="let row; columns: ['label', 'toggle', 'actions']"></tr>
            </table>

          </mat-expansion-panel>
        }
      </mat-accordion>
    }
  </ng-container>

</section>

